// Centralized Meta Pixel event helper. Pixel is initialized once in index.html —
// this module only sends events and NEVER re-initializes fbq.
const canTrack = () => typeof window !== "undefined" && typeof window.fbq === "function";

const guard = (storage, dedupKey) => {
  if (!dedupKey) return true;
  try {
    const k = `cm_px_${dedupKey}`;
    if (storage.getItem(k)) return false;
    storage.setItem(k, "1");
    return true;
  } catch {
    return true;
  }
};

// Custom funnel event. dedupKey (optional) = fire at most once per browser session.
export function trackCustom(name, params = {}, dedupKey = null) {
  try {
    if (!canTrack()) return;
    if (!guard(window.sessionStorage, dedupKey)) return;
    window.fbq("trackCustom", name, params);
  } catch {}
}

// Meta standard event. dedupKey (optional) = fire at most once EVER (localStorage).
export function trackStandard(name, params = {}, dedupKey = null) {
  try {
    if (!canTrack()) return;
    if (!guard(window.localStorage, dedupKey)) return;
    window.fbq("track", name, params);
  } catch {}
}

export function newExamSessionId() {
  return `exam_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}
